// @flow
export const NotifyBannerText = () => (
  <>
    <strong>Notify and email settings will be saved and apply to all users added via this integration.</strong> Settings
    may be changed at any time.
  </>
);
